module.exports = __webpack_public_path__ + "img/jeep.895253e8.jpeg";